import axios from "axios";
import { useMutation } from "react-query";

import type { BLPOfficeRiskDto } from "./getBLPDashboard";

const apiBaseUrl =
  process.env.REACT_APP_API_BASEURL +
  "/BusinessLicensePermitDashboard/OfficeRiskFilter";

export interface OfficeRiskFilterRequest {
  officeIds: number[];
  top?: number;
}

const normalizeOfficeIds = (officeIds: number[] = []): number[] => {
  return Array.from(
    new Set(
      officeIds
        .map(Number)
        .filter((officeId) => Number.isFinite(officeId) && officeId > 0)
    )
  ).slice(0, 15);
};

export const getOfficeRiskFilter = async (
  request: OfficeRiskFilterRequest
): Promise<BLPOfficeRiskDto[]> => {
  const officeIds = normalizeOfficeIds(request.officeIds);

  const top = request.top && request.top > 0 ? Math.min(request.top, 15) : 10;

  const params = new URLSearchParams();

  officeIds.forEach((officeId) => {
    params.append("officeIds", officeId.toString());
  });

  params.append("top", top.toString());

  const response = await axios.get<BLPOfficeRiskDto[]>(apiBaseUrl, {
    params,
  });

  return response.data ?? [];
};

export const useOfficeRiskFilter = () => {
  return useMutation<BLPOfficeRiskDto[], Error, OfficeRiskFilterRequest>(
    getOfficeRiskFilter
  );
};
